const ErrorMessage = ({ children, error, visible }) => {
  return <p className="text-sm h-[20px] font-opensans text-red-500 m-0 mt-2">{children}</p>;
};

export default ErrorMessage;
